// useGlobalMethods.js
import { useRouter } from 'vue-router';

export function useGlobalMethods() {
  const router = useRouter();

  // 需要完整重整的頁面改用 location.href，避免只走前端路由造成狀態不一致。
  const redirectWithReload = (path) => {
    location.href = location.origin + path;
  };

  // 依登入前記錄的 info 導回來源頁面。
  // 8.16 起不清除 info，避免活動頁登出後缺少回跳依據。
  const afterLoginRouter = () => {
    const info = sessionStorage.getItem("info");

    if (!info) {
      router.push("/");
      return;
    }

    const isHome = location.pathname === "/";

    // 統購入口：若已在授權頁則回首頁，否則導去授權頁。
    if (info === "1") {
      if (location.pathname === "/AccountInfo") {
        router.push("/");
      } else {
        router.push("/AccountInfo");
      }
      return;
    }

    // 舊版活動頁回跳。
    if (info === "2") {
      if (isHome) {
        router.push("/");
      } else {
        redirectWithReload("/Activity_Info");
      }
      return;
    }

    // goodkid 系列回跳。
    if (info === "3") {
      if (isHome) {
        router.push("/");
      } else {
        redirectWithReload("/goodkid");
      }
      return;
    }

    if (info === "4") {
      if (isHome) {
        router.push("/");
      } else {
        redirectWithReload("/goodkid/Activity_CreateClass");
      }
      return;
    }

    // Activity_Event 需要保留 id 才能載入正確活動資料。
    if (info === "Activity_Event" || info === "activity_event") {
      const currentUrl = new URL(window.location.href);
      const activityEventId = sessionStorage.getItem("activityEventId") || currentUrl.searchParams.get("id") || "";

      if (isHome) {
        router.push("/");
      } else {
        const query = activityEventId ? "?id=" + encodeURIComponent(activityEventId) : "";
        redirectWithReload("/Activity_Event" + query);
      }
      return;
    }

    // 其餘活動先走白名單對照，找不到就退回 /{info}。
    const urlPathname = getUrlPathname(info);
    const fallbackPath = "/" + info;
    redirectWithReload(urlPathname || fallbackPath);
  };

  return {
    afterLoginRouter
  };
}
function getUrlPathname(info) {
  const pathnameMap = {
    Activity_InfoVer2: "/Activity_InfoVer2",
    goodkid2025: "/goodkid2025",
    goodkid2026_preview: "/goodkid2026_preview",
    goodkid2026test: "/goodkid2026test",
    goodkidtest_20260508: "/goodkidtest_20260508",
    test0522: "/test0522",
    activity_clone_template: "/activity_clone_template",
    goodkid20260827: "/goodkid20260827",
    goodkid2026demo0612: "/goodkid2026demo0612",
    mainvisual_test: "/mainvisual_test",
    goodkid2026: "/goodkid2026",
    Activity_InfoVer3: "",
  };

  return pathnameMap[info] || "";
}
